import axios from 'axios';
import { Cookies } from 'react-cookie';
import { selector } from 'recoil';
import { URL_FOUNDATION } from '../config/keys';


export type GroupWithMembers = {
	id: number
	name: string,
	user_ids?: number[]
}

// -----------------------[ ATOM ]----------------------- //
export const AGroups = selector<GroupWithMembers[]>({
	key: 'AGroups',
	get: async() => getGroups()
});

// -----------------------[ API ]------------------------ //
const cookies = new Cookies();
const token: string | null = cookies.get('id_token') || null;

axios.defaults.headers.common.Authorization = `${token ?? ''}`;

export async function getGroups(): Promise<GroupWithMembers[]> {
	try {
		return await axios({
			method: 'get',
			url: `${URL_FOUNDATION}/api/v2/groups`
		}).then(res => res.data);
	} catch (e) {
		console.error(e);
		return [];
	}
}
